import {css} from '@emotion/react'
import {colors} from '../constants'
import Confetti from '../images/protection/success/confetti.svg'

const translationsData = {
    en: {
        title: `Success!`,
    },
    de: {
        title: `Glückwunsch!`,
    },
}

const SuccessConfetti = ({languageCode = `en`}) => {
    const translations = translationsData[languageCode]
    return (
        <div
            className="title-container"
            css={css`
                position: relative;
                height: 65px;
                width: ${languageCode === `de` ? '275px' : '180px'};
                svg {
                    position: absolute;
                    top: -21px;
                    left: 50%;
                    margin-left: -110px;
                }
                h1 {
                    position: relative;
                    color: ${colors.brandBlue};
                    font-size: 40px;
                    font-weight: 600;
                }
            `}
        >
            <Confetti />
            <h1>{translations.title}</h1>
        </div>
    )
}

export default SuccessConfetti
